import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * Pipeline-drugs RTK Query slice — endpoints not related to "perspective"
 * (which lives in pipelinePerspective.js). Currently powers:
 *   - useRecentlyApprovedQuery → dashboard "NEW Approved" card + Discover
 *     tab showing pipeline drugs that recently graduated to FDA-approved.
 *
 * Rooted at /pipeline-drugs/ so paths mirror the backend controller
 * routes 1:1.
 */
export const pipelineDrugsApi = createApi({
  reducerPath: "pipelineDrugsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/pipeline-drugs/`,
    prepareHeaders: (headers) => {
      if (typeof document === "undefined") return headers;
      const cookies = document.cookie.split(";");
      for (const c of cookies) {
        const t = c.trim();
        if (t.startsWith("token=")) {
          headers.set("authorization", `Bearer ${t.slice("token=".length)}`);
          break;
        }
      }
      return headers;
    },
  }),
  tagTypes: ["PipelineDrugs"],
  endpoints: (builder) => ({
    recentlyApproved: builder.query({
      query: ({ limit = 10 } = {}) => ({
        url: `recently-approved?limit=${limit}`,
        method: "GET",
      }),
      providesTags: [{ type: "PipelineDrugs", id: "recently-approved" }],
    }),
  }),
});

export const { useRecentlyApprovedQuery } = pipelineDrugsApi;
